define(function ( require ) {
    'use strict';

    var Backbone = require('backbone');
    var AppConfig = require('config/application');
    var LPTCollection = require('vendor/Backbone/LPTCollection');

    var model = Backbone.Model.extend({});

    return LPTCollection.extend({
        url: AppConfig.host + '/rest/missed-calls',
        model: model,
        parse: function ( response ) {
            if (typeof response.result != 'undefined') {
                return response.result;
            } else {
                return response;
            }
        }
    });
});